export default "__VITE_ASSET__CkoVBmQC__"